import * as Sentry from "@sentry/react";

let initialized = false;

export function initSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();
  if (!dsn || initialized) return;

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_ENV ?? "production",
    release: process.env.REACT_APP_COMMIT_SHA ?? process.env.REACT_APP_VERSION,
    // XSS で盗まれた token 等が breadcrumb に載らないよう fetch/xhr のデフォルト記録を抑制
    integrations: (integrations) =>
      integrations.filter(
        (i) => i.name !== "Breadcrumbs"
      ),
  });

  initialized = true;
}

export function isSentryInitialized(): boolean {
  return initialized;
}

export function sentrySetUser(userId: string | undefined): void {
  if (!initialized) return;
  Sentry.setUser(userId ? { id: userId } : null);
}

export function sentryCaptureException(
  error: unknown,
  extras?: Record<string, unknown>
): void {
  if (!initialized) return;
  Sentry.withScope((scope) => {
    if (extras) scope.setExtras(extras);
    Sentry.captureException(error);
  });
}

export function sentryCaptureMessage(
  message: string,
  level: "info" | "warning" | "error",
  extras?: Record<string, unknown>
): void {
  if (!initialized) return;
  Sentry.withScope((scope) => {
    if (extras) scope.setExtras(extras);
    Sentry.captureMessage(message, level);
  });
}
